import request from "@/utils/request"

// 获取推荐栏数据
export function getQueryItemPagedList(data) {
  return request({
    url: "/api/RecommendationList/QueryItemPagedList",
    method: "GET",
    params: data
  });
}

// 获取推荐栏数据id
export function getGetEntryCA() {
  return request({
    url: "/api/RecommendationList/GetEntryCA",
    method: "GET",
  });
}

export function getsignature(data) {
  // 根据id获取词条数据
  return request({
    url: `/signature`,
    method: "get",
    params: data
  });
}
export function getRecommendEntry(data) {
  // 推荐词条
  return request({
    url: "/api/Entry/GetRecommendEntry",
    method: "get",
    data: data,
  });
}
export function getEditEntry(data) {
  // 根据id获取词条数据
  return request({
    url: `/api/EntryIndexNew/GetDatasById/${data}`,
    method: "GET",
  });
}
export function getEncycData(data) {
  // 获取词条数据
  return request({
    url: `/api/EntryIndexNew/GetDatasByTitle/${data}`,
    method: "GET",
  });
}
export function getEntryExtendImage(data) {
  // 获取富文本关联图片
  return request({
    url: `/api/EntryExtendDetail/GetExtendImages/${data}`,
    method: "GET",
  });
}
// 趣味百科
export function getEncycList() {
  // 有趣的隧道百科
  return request({
    url: "/api/Interest/QueryAll",
    method: "GET",
  });
}

// 词条列表
export function getEntryList(data) {
  // 获取词条列表
  return request({
    url: `/api/EntryIndexNew/Search/${data.keyword}/${data.page}/${data.pageSize}`,
    method: "GET",
    data: data,
  });
}
export function getKnowhowList(data) {
  // 获取knowhow
  return request({
    url: "",
    method: "POST",
    data: data,
  });
}
export function getEntryBrowseCount(data) {
  // 获取词条浏览数
  return request({
    url: `/api/Entry/GetBrowseCount/${data}`,
    method: "GET",
  });
}
// 词条详情
export function getVideoAuth(data) {
  // 获取视频播放凭证
  return request({
    url: `/api/EntryVideo/GetVideoPlayRequirement/${data.videoId}`,
    method: "GET",
  });
}
// 文章页
export function getArticleData(data) {
  // 获取文章数据
  return request({
    url: `/api/CyclopediaArticle/SingleOrDefault/${data}`,
    method: "GET",
  });
}
export function getExpendList(data) {
  // 获取拓展关联
  return request({
    url: `/api/CyclopediaArticle/QueryPagedList?${data}`,
    method: "GET"
  });
}
export function getArticleBrowseCount(data) {
  // 获取文章浏览次数
  return request({
    url: `/api/CyclopediaArticle/GetArticleBrowseCount/${data}`,
    method: "GET",
  });
  // /api/CyclopediaArticle/GetArticleBrowseCount/
}
export function getMenusList(data) {
  // 获取总目录列表
  return request({
    url: `/api/EntryIndexNew/GetPage/${data.pageIndex}/${data.pageSize}${data.type ? "/" + data.type : ""
      }`,
    method: "POST",
  });
}

/**
 * 获取访问流量
 * @param pageIndex 当前页标
 * @param pageSize 每页大小
 * @param QueryModel 查询条件类
 * @returns {*}
 */
export function reqGetAccessList(pageIndex, pageSize, QueryModel) {
  return request({
    methods: "get",
    url: "/api/EntryBrowseLog/QueryRankingList",
    params: {
      pageIndex,
      pageSize,
    },
  });
}

/**
 * 词条排序
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getRedactOrderScore(data) {
  return request({
    url: "/api/Entry/RedactOrderScore",
    method: "POST",
    data,
  });
}

/**
 * 获取词条数据
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getOrderScorePage(data) {
  return request({
    url: "/api/Entry/GetOrderScorePage",
    method: "GET",
    params: data,
  });
}

// 获取词条分类
export function getCategoryList(data) {
  return request({
    url: "/api/EntryState/QueryPage",
    method: "POST",
    data,
  });
}

// 获取词条数据新接口
export function getWebOrderScorePage(data) {
  return request({
    url: "/api/Entry/GetWebOrderScorePage",
    method: "GET",
    params: data,
  });
}

// 获取扩展词条数据
export function getExtendEntryList(data) {
  return request({
    url: "/api/CyclopediaArticle/QueryPagedList",
    method: "GET",
    params: data
  });
}

// 隧道视频列表
export function getEntryVideoList(data) {
  return request({
    url: "/api/EntryVideo/QueryPage",
    method: "POST",
    data: data,
  });
}

// 查询视频数据
export function getEntryVideoQueryId(id) {
  return request({
    url: `/api/EntryVideo/QueryId/${id}`,
    method: 'GET'
  });
}

// 词条视频 获取前台排序列表
export function getVideoWebOrderScorePage(params) {
  return request({
    url: "/api/EntryVideo/GetWebOrderScorePage",
    method: "GET",
    params
  });
}

//获取扩展 和 known数据
export function getEntryExtendOverview(params) {
  return request({
    url: "/api/EntryExtend/Overview",
    method: "GET",
    params
  });
}

// 获取上下篇
export function getCAPreviousNext(params) {
  return request({
    url: "/api/CyclopediaArticle/PreviousNext",
    method: "get",
    params
  });
}

// 获取总览（不分类）
export function getEntryOverviewPage(params) {
  return request({
    url: "/api/EntryExtend/OverviewPage",
    method: "GET",
    params
  });
}